export default "__VITE_ASSET__HB$DLdfn__"